import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingAddress = createSelector(coworkingSelector, coworking => coworking?.geo.addressText || '');
